import {Routes, Route} from 'react-router-dom';

import { Register } from './Components/RegistrationForm/Register';
import { Contact } from './Components/Contact/Contact.js';
import { About } from './Components/About/About.js';
import { HomePage } from './Components/HomePage/HomePage';
import { PrivacyPolicy } from './Components/PrivacyPolicy/PrivacyPolicy';
import './App.css'; // Importing the CSS file for styling
import {Usuario} from './Components/User/User.js';
import {HeaderMTB} from './Components/HeaderMTB/HeaderMTB.js';
export default function App() {
    return (
        <>
            <Usuario />
            
            <HeaderMTB />
    
        
            <Routes>
                <Route path="/" element ={ <HomePage/> } />
                <Route path="/register" element={ <Register/> } />
                <Route path="/contact" element={ <Contact/> } />
                <Route path="/about" element={ <About/> } />
                <Route path="/privacy" element={ <PrivacyPolicy/> } />
                

            </Routes>

            <br/>
            
        </>
    );
  
}

